import { render, staticRenderFns } from "./PlanosForm.vue?vue&type=template&id=7cf16048&scoped=true&"
import script from "./PlanosForm.vue?vue&type=script&lang=js&"
export * from "./PlanosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf16048",
  null
  
)

export default component.exports